import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Panel} from '@sabre/spark-react'
import t from 'tcomb-form'
import weatherFormModel from './model'
import options from './options'
import withProgress from 'shared/hoc/progress/index'

const Form = t.form.Form

const defaultFormState = (types) => ({
    count: "1",
    types: defaultTypes(types)
})

const typesModel = (types) => {
    let Types = types !== undefined
        ? types.reduce((result, item) => {
            result[item.Type] = t.Bool
            return result
        }, {})
        : {}
    Types.All = t.Bool
    return Types
}

const defaultTypes = (types) => {
    let Types = types !== undefined
        ? types.reduce((result, item) => {
            result[item.Type] = item.default
            return result
        }, {})
        : {}
    Types.All = false
    return Types
}

export default class WeatherForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            options: options,
            value: defaultFormState(this.props.weatherTypes)
        }
    }

    componentDidMount() {
        this.props.actions.onGetWeatherTypes()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.weatherTypes !== this.props.weatherTypes) {
            this.setState({value: defaultFormState(nextProps.weatherTypes)})
        }
    }

    getWeatherFormModel() {
        const Types = typesModel(this.props.weatherTypes)
        weatherFormModel.types = t.struct(Types)
        return t.struct(weatherFormModel)
    }

    selectTypes = (isSelected) => {
        const defaultTypes = this.props.weatherTypes.reduce((result, item) => {
            result[item.Type] = isSelected
            return result
        }, {})
        defaultTypes.All = isSelected
        this.setState({value: {...this.state.value, types: defaultTypes}})
    }

    validateWeatherTypes() {
        const isAnyTypeSelected = this.state.value.types !== undefined
            ? Object.keys(this.state.value.types).some(type => this.state.value.types[type])
            : false
        const options = t.update(this.state.options, {
            fields: {
                types: {
                    hasError: {'$set': !isAnyTypeSelected}
                }
            }
        });
        this.setState({options: options})
        return isAnyTypeSelected
    }

    isAnyTypeUnchecked = (value) => {
        return Object.keys(value.types)
            .filter(type => type !== 'All')
            .some(type => !value.types[type])
    }

    hasAnyTypeChanged = (path) => {
        return path[0] === 'types' && path[1] !== 'All'
    }

    hasSelectAllChanged = (value) => {
        return value.types.All !== this.state.value.types.All
    }

    onChange = (value, path) => {
        if (this.hasAnyTypeChanged(path) && this.isAnyTypeUnchecked(value)) {
            this.setState({value: {...value, types: {...value.types, All: false}}})
        }
        else if (this.hasSelectAllChanged(value)) {
            this.selectTypes(value.types.All)
        }
        else {
            this.setState({value: value})
        }
    }

    onSubmit = (e) => {
        e.preventDefault()
        const areTypesValid = this.validateWeatherTypes()
        if (this.refs.form.getValue() && areTypesValid) {
            this.props.actions.onGetWeather(this.state.value)
        }
    }

    render() {
        const PanelWithProgress = this.props.loading ? withProgress(Panel) : Panel
        return (
            <PanelWithProgress loading={this.props.loading}>
                <Panel.Content>
                    <Form
                        ref="form"
                        type={this.getWeatherFormModel()}
                        options={this.state.options}
                        value={this.state.value}
                        onChange={this.onChange}
                    />
                    <nav className="spark-btn-group">
                        <button onClick={this.onSubmit} disabled={this.props.submitDisabled}
                                className="spark-btn spark-btn--sm">Get weather
                        </button>
                    </nav>
                </Panel.Content>
            </PanelWithProgress>
        )
    }
}

WeatherForm.propTypes = {
    actions: PropTypes.object.isRequired,
    submitDisabled: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    weatherTypes: PropTypes.array
}


// WEBPACK FOOTER //
// ./src/screens/weather/components/WeatherForm/form.js